import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export const ContainerDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  overflow-y: auto;
  flex-direction: column;
`

export const ImageContainerDiv = styled.div`
  gap: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px 20px 20px;
`

export const Image = styled.img`
  width: 100%;
  height: 262px;
  object-fit: cover;
  border-radius: 4px;
  object-position: center;

  @media (min-width: ${BREAKPOINT_SM}) {
    height: 333px;
  }
`
